import React from 'react'
import { connect } from 'react-redux'
import { removeNotification } from '../actions'

const Notification = ({ notifications, removeNotification }) => (
  <div className="notifications">
    {notifications.map(notification =>
      <div key={notification.id} className={ `notification ${notification.style}` }>
        <button className="delete" onClick={() => removeNotification(notification.id)}></button>
        {notification.text}
        <script>{setTimeout(() => removeNotification(notification.id), 3000)}</script>
      </div>
    )}
  </div>
)

export default connect(
  state => ({ notifications: state.notifications }),
  { removeNotification }
)(Notification)


// WEBPACK FOOTER //
// ./src/components/Notification.js